export type Lang = "en" | "es";

const LANG_KEY = "cws-lang";

export function getLang(): Lang {
  if (typeof window === "undefined") return "en";
  try {
    const stored = window.localStorage.getItem(LANG_KEY) as Lang | null;
    if (stored === "en" || stored === "es") return stored;
  } catch { /* noop */ }
  if (typeof navigator !== "undefined" && navigator.language?.toLowerCase().startsWith("es")) return "es";
  return "en";
}

export function setLang(lang: Lang) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LANG_KEY, lang);
    window.dispatchEvent(new Event("cws:lang-changed"));
  } catch { /* noop */ }
}

export const CONSENT_T = {
  en: {
    title: "Your privacy choices",
    body: "California Waste Solutions uses cookies and similar technologies that are necessary for basic website functionality, security, form submission, and site operation. We may use additional cookies only if enabled by you or as otherwise disclosed in our Privacy Policy.",
    acceptAll: "Accept All",
    rejectAll: "Reject Non-Essential",
    manage: "Manage Preferences",
    save: "Save Preferences",
    dismiss: "Dismiss cookie notice",
    privacy: "Privacy Policy",
    cookies: "Cookie Notice",
    accessibility: "Accessibility Assistance",
    prefsTitle: "Cookie Preferences",
    prefsDesc: "Choose which categories of cookies you allow. Strictly necessary cookies are always on.",
    alwaysOn: "Always On",
    gpcDetected: "Global Privacy Control detected. Non-essential cookies are off by default.",
    toastSavedAll: "All cookies accepted.",
    toastSavedNone: "Non-essential cookies disabled.",
    toastSavedCustom: "Preferences saved.",
    chipLabel: "Cookies",
    chipOn: "On",
    chipOff: "Off",
    chipCustomize: "Customize",
    chipDisclaimer: "By using this site, you agree to our",
    chipTerms: "Terms",
    chipAnd: "and",
    chipCookies: "Cookie Policy",
    chipGpcLock: "Locked by Global Privacy Control",

    cats: {
      necessary: { title: "Strictly Necessary Cookies", desc: "Required for basic website functionality, security, forms, and site operation." },
      analytics: { title: "Performance or Analytics Cookies", desc: "Help us understand website usage and improve performance, if enabled." },
      functional: { title: "Functional Cookies", desc: "Help remember user preferences and improve site experience, if enabled." },
      advertising: { title: "Advertising or Tracking Cookies", desc: "Used only if CWS later enables advertising, tracking pixels, or cross-context behavioral advertising technologies." },
    },
  },
  es: {
    title: "Tus opciones de privacidad",
    body: "California Waste Solutions utiliza cookies y tecnologías similares necesarias para el funcionamiento básico del sitio, la seguridad, el envío de formularios y la operación del sitio. Podemos usar cookies adicionales solo si las habilitas o según se divulgue en nuestra Política de Privacidad.",
    acceptAll: "Aceptar Todo",
    rejectAll: "Rechazar No Esenciales",
    manage: "Administrar Preferencias",
    save: "Guardar Preferencias",
    dismiss: "Cerrar aviso de cookies",
    privacy: "Política de Privacidad",
    cookies: "Aviso de Cookies",
    accessibility: "Asistencia de Accesibilidad",
    prefsTitle: "Preferencias de Cookies",
    prefsDesc: "Elige qué categorías de cookies permites. Las cookies estrictamente necesarias siempre están activadas.",
    alwaysOn: "Siempre Activo",
    gpcDetected: "Control Global de Privacidad detectado. Las cookies no esenciales están desactivadas.",
    toastSavedAll: "Todas las cookies aceptadas.",
    toastSavedNone: "Cookies no esenciales desactivadas.",
    toastSavedCustom: "Preferencias guardadas.",
    chipLabel: "Cookies",
    chipOn: "Activadas",
    chipOff: "Desactivadas",
    chipCustomize: "Personalizar",
    chipDisclaimer: "Al usar este sitio, aceptas nuestros",
    chipTerms: "Términos",
    chipAnd: "y la",
    chipCookies: "Política de Cookies",
    chipGpcLock: "Bloqueado por Control Global de Privacidad",

    cats: {
      necessary: { title: "Cookies Estrictamente Necesarias", desc: "Requeridas para la funcionalidad básica, seguridad, formularios y operación del sitio." },
      analytics: { title: "Cookies de Rendimiento o Analítica", desc: "Nos ayudan a entender el uso del sitio y mejorar el rendimiento, si están habilitadas." },
      functional: { title: "Cookies Funcionales", desc: "Ayudan a recordar preferencias y mejorar la experiencia, si están habilitadas." },
      advertising: { title: "Cookies de Publicidad o Seguimiento", desc: "Se usan solo si CWS habilita publicidad, píxeles de seguimiento o tecnologías de publicidad conductual entre contextos." },
    },
  },
} as const;
